import { ChangeDetectionStrategy, Component, HostBinding, input, InputSignal } from '@angular/core';
import { IdService } from '../../services/id.service';

@Component({
  selector: 'td-wb-analytics-context',
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnalyticsContextComponent {
  readonly analyticsContext: InputSignal<string | undefined> = input<string | undefined>(undefined);

  @HostBinding('attr.aria-hidden') hidden: boolean = true;
  @HostBinding('class.td-wb-vh') visuallyHidden: boolean = true;

  @HostBinding('attr.id') id: string;

  @HostBinding('attr.data-td-wb-analytics-context-id')
  get analyticsContextId(): string | undefined {
    return this.analyticsContext();
  }

  constructor(private idService: IdService) {
    this.id = this.idService.generateNamespaceSequentialId('td-wb-analytics-context');
  }
}
